document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.js-video-reviews-slider');
  if (slider) {
    new Swiper(slider, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }

  const modal = document.querySelector('.js-video-reviews-modal');
  const modalInner = document.querySelector('.js-video-reviews-modal-inner');
  const modalVideo = document.querySelector('.js-video-reviews-modal-video');
  const closeBtn = document.querySelector('.js-video-reviews-modal-close');

  document.querySelectorAll('.js-video-reviews-video-wrap').forEach((wrap) => {
    wrap.addEventListener('click', function () {
      const video = wrap.querySelector('video');
      const videoUrl = video?.dataset.videoUrl;

      if (videoUrl && modal && modalVideo) {
        modal.classList.add('active');
        modalVideo.src = videoUrl;
        modalVideo.play();
      }
    });
  });

  if (closeBtn && modal) {
    closeBtn.addEventListener('click', () => {
      modal.classList.remove('active');
      modalVideo.pause();
      modalVideo.src = '';
    });
  }

  if (modal && modalInner) {
    modal.addEventListener('click', (e) => {
      if (!modalInner.contains(e.target)) {
        modal.classList.remove('active');
        modalVideo.pause();
        modalVideo.src = '';
      }
    });
  }

  document.querySelectorAll('.js-video-reviews-video-preview').forEach((videoEl) => {
    videoEl.addEventListener('loadedmetadata', () => {
      const timeContainer = videoEl.closest('.js-video-reviews-video-wrap')?.querySelector('.js-video-reviews-video-time');
      if (timeContainer) {
        const minutes = Math.floor(videoEl.duration / 60).toString().padStart(2, '0');
        const seconds = Math.floor(videoEl.duration % 60).toString().padStart(2, '0');
        timeContainer.textContent = `${minutes}:${seconds}`;
      }
    });
  });
});
